import { Injectable } from '@angular/core';
import { UtilService } from '../modules/shared/services';
import { AuthService } from './auth/auth.service';
import { ActivatedRoute, Params, Router, UrlTree } from '@angular/router';
import { BusinessUnitService } from '../modules/business-units/services';
import { IBusinessUnit } from '../modules/business-units/models';
import { ToastrService } from 'ngx-toastr';
import { DataService } from './data/data.service';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { toggleLoading } from '../modules/redux';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  private loadingSubject = new BehaviorSubject<{ loading: boolean, message: string }>({ loading: false, message: '' });
  public loading$: Observable<{ loading: boolean, message: string }> = this.loadingSubject.asObservable(); 


  constructor(
    private router: Router,
    private store: Store,
    // private activatedRoute: ActivatedRoute,
    // private businessUnitService: BusinessUnitService,
    private toastrService: ToastrService,
    // private dataService: DataService
  ) { }


  // Show/Hide loader
  public loader(loading: boolean = true): void { 
    if (loading) {
      this.setLoading(true);
    } else {
      setTimeout(() => this.setLoading(false), 900); // add a slight delay to prevent flickering for fast operations
    }
  }

  // show the loader with a message
  public loaderWithMessage(message: string): void { this.setLoading(true, message); }

  show(): void { this.setLoading(true); }

  hide(): void { this.setLoading(false); }

  setLoading(value: boolean, message: string = ''): void {
    // this.loadingSubject.next({ loading: value, message: message });
    this.store.dispatch(toggleLoading({ loading: value, message: message })); 
  }
  
  sendUserToErrorPage(error: string) {
    this.router.navigate(['/error'], {
      state: {
        message: error
      }
    })
  }



  // public GetRedirectUrlAfterLogin (queryParams?: Params): Observable<UrlTree> {
  //   console.log("-----> Getting redirect URL after login with query params: ", queryParams);
  //   return this.businessUnitService.getUserBusinessUnits().pipe(
  //     map((bus: IBusinessUnit[]) => {
  //       console.log("Business units for user", bus);
  //       if (bus.length == 0) {
  //         this.toastrService.info("No Business Units assigned to your user account. Please contact support.");
  //         throw new Error("No Business Units assigned to user");
  //       }

  //       var baseUrlTree = this.router.createUrlTree(['/', bus[0].slug, 'dashboard']);

  //       if (!queryParams) {
  //         // if there are no query params, just send to the first business unit dashboard
  //         return baseUrlTree;
  //       }

  //       // not handle a request that has multiple business units yet, so just send to first one for now
  //       var action = queryParams['action'];
  //       if (action == "redirect") {
  //         var redirectUrl = queryParams['redirectUrl'];
  //         if (!!redirectUrl) {
  //           // there is a valid redirect URL
  //           console.log("Redirecting to requested path: " + redirectUrl);
  //           return this.router.parseUrl(redirectUrl);
  //         }
  //         else {
  //           // no valid redirect URL
  //           return baseUrlTree;
  //         }
  //       }
  //       else if (action == "deal-interest") {
  //         var dealId = queryParams['dealId'];
  //         // the user has to have an investor BU to be sent there!
  //         var investorBU = bus.filter(x => x.profile.toLowerCase() == 'investor');

  //         if (investorBU.length == 0) {
  //           this.toastrService.error("You don't have access to the requested page. Please contact support.");
  //           return baseUrlTree;
  //         }
  //         else {
  //           if (!!dealId) {
  //             console.log("Redirecting to deal interest page for deal ID: " + dealId);
  //             return this.router.createUrlTree(['/', investorBU[0].slug, 'deal-interest', dealId]);
  //           }
  //           else {
  //             return baseUrlTree;
  //           }
  //         }
  //       }

  //       return baseUrlTree;
  //     })
  //   )
  // }

  
  // public async RedirectAfterLogin(queryParams: Params): Promise<void> {

  //   console.log("Redirecting after login with redirect path = ", queryParams);

  //   return new Promise<void>((resolve, reject) => {
  //     this.businessUnitService.getUserBusinessUnits().subscribe({
  //       next: (bus: IBusinessUnit[]) => {
  //         console.log("Business units for user", bus);
  //         if (bus.length == 0) {
  //           this.toastrService.info("No Business Units assigned to your user account. Please contact support.");
  //           reject();
  //           return;
  //         }
  //         else {

  //           // there are multiple business units, so we need to check if there is a redirect path and if it is valid
  //           var action = queryParams['action'];
  //           if (action == "redirect") {

  //           }
  //           else if (action == "deal-interest") {

  //           }
  //           else {
  //             var firstBU = bus[0];
  //             this.dataService.setCurrentBusinessUnit(firstBU);
  //             return this.router.navigate(['/', firstBU.slug, 'dashboard']);
  //           }



  //           // // see if there is a redirect path set from util service
  //           // if (!!redirectPath) {
  //           //   console.log("Redirecting to requested path: " + redirectPath);
  //           //   return this.router.navigateByUrl(redirectPath);
  //           // }
  //           // else {
  //           //   var firstBU = bus[0];
  //           //   this.dataService.setCurrentBusinessUnit(firstBU);
  //           //   return this.router.navigate(['/', firstBU.slug, 'dashboard']);
  //           // }
  //         }
  //       },
  //       error: (err: any) => {
  //         console.error("Error getting business units for user", err);
  //         this.toastrService.error("Error getting user Business Units");
  //         this.sendUserToErrorPage("Error getting assigned Business Units for user. Please try again in a few minutes.");
  //         reject();
  //       }
  //     });

  //   });



    // // get the business units for user
    // this.businessUnitService.getUserBusinessUnits().subscribe({
    //   next: (bus: IBusinessUnit[]) => {
    //     console.log("Business units for user", bus);
    //     if (bus.length == 0) {
    //       this.toastrService.info("No Business Units assigned to your user account. Please contact support.");
    //       return;
    //     }
    //     else {
    //       // see if there is a redirect path set from util service
    //       if (!!redirectPath) {
    //         console.log("Redirecting to requested path: " + redirectPath);
    //         this.router.navigateByUrl(redirectPath);
    //       }
    //       else {
    //         var firstBU = bus[0];
    //         this.dataService.setCurrentBusinessUnit(firstBU);
    //         this.router.navigate(['/', firstBU.slug, 'dashboard']).finally(() => {
    //           console.log("Redirecting to Business Unit: " + firstBU.displayName);
    //         });
    //       }
    //     }
    //   },
    //   error: (err: any) => {
    //     console.error("Error getting business units for user", err);
    //     this.toastrService.error("Error getting user Business Units");
    //     this.sendUserToErrorPage("Error getting assigned Business Units for user. Please try again in a few minutes.");
    //   }
    // });
  // }
}
